import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { LoginPageResolve } from './login-page-resolve.service';
import { NotAuthGuard } from '../../core/auth/not-auth.guard';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: 'login',
				component: LoginComponent,
				canActivate: [NotAuthGuard],
				resolve: {
					model: LoginPageResolve
				}
			}
		])
	],
	exports: [
		RouterModule
	],
	providers: [
		LoginPageResolve
	]
})
export class LoginRoutingModule {
}
